// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e00b33db","952":"b00907ae"}[chunkId] + ".chunk.js";
};